import type {
  AdditionalRetainerProjectPayload,
  AddRetainerProjectPayload,
  JsonAddRetainerProjectPayload,
} from 'src/store/retainers/terms/types';
import { RetainerTermsCommands } from 'src/store/retainers/terms/types';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { wsMmSend, createMmWsAction } from '@skynet/data-ws-mm';

export const addRetainerProject = createMmWsAction<
  AddRetainerProjectPayload,
  JsonAddRetainerProjectPayload
>('retainers/addProject', (data: AddRetainerProjectPayload) => ({
  command: RetainerTermsCommands.AddProject,
  ...data,
}));

export type UpdateRetainerProjectPayload = Partial<AddRetainerProjectPayload> &
  AdditionalRetainerProjectPayload;

export const updateRetainerProject = createAsyncThunk(
  'retainers/updateRetainer',
  (data: UpdateRetainerProjectPayload, thunkApi) => {
    thunkApi.dispatch(
      wsMmSend({
        command: RetainerTermsCommands.UpdateRetainer,
        ...data,
      }),
    );

    return data;
  },
);
